function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import { fastObjectShallowCompare } from '@mui/x-internals/fastObjectShallowCompare';
import { warnOnce } from '@mui/x-internals/warning';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { useLazyRef } from "./useLazyRef.js";
function isOutputSelector(selector) {
    return selector.acceptsApiRef;
}
// TODO v8: Remove this function
function applySelector(apiRef, selector) {
    if (isOutputSelector(selector)) {
        return selector(apiRef);
    }
    return selector(apiRef.current.state);
}
// TODO v8: Rename this function to `applySelector`
function applySelectorV8(apiRef, selector, args, instanceId) {
    if (isOutputSelector(selector)) {
        return selector(apiRef, args);
    }
    return selector(apiRef.current.state, instanceId);
}
var defaultCompare = Object.is;
export var objectShallowCompare = fastObjectShallowCompare;
var arrayShallowCompare = function(a, b) {
    if (a === b) {
        return true;
    }
    return a.length === b.length && a.every(function(v, i) {
        return v === b[i];
    });
};
export var argsEqual = function(prev, curr) {
    var fn = Object.is;
    if (curr instanceof Array) {
        fn = arrayShallowCompare;
    } else if (curr instanceof Object) {
        fn = objectShallowCompare;
    }
    return fn(prev, curr);
};
var createRefs = function() {
    return {
        state: null,
        equals: null,
        selector: null,
        args: undefined
    };
};
var EMPTY = [];
var emptyGetSnapshot = function() {
    return null;
};
// TODO v8: Remove this function
export var useGridSelector = function(apiRef, selector) {
    var equals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultCompare;
    if (process.env.NODE_ENV !== 'production') {
        if (!apiRef.current.state) {
            warnOnce([
                'MUI X: `useGridSelector` has been called before the initialization of the state.',
                'This hook can only be used inside the context of the grid.'
            ]);
        }
    }
    var refs = useLazyRef(createRefs);
    var didInit = refs.current.selector !== null;
    var _React_useState = _sliced_to_array(React.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : applySelector(apiRef, selector)), 2), state = _React_useState[0], setState = _React_useState[1];
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    var subscribe = React.useCallback(function() {
        if (refs.current.subscription) {
            return null;
        }
        refs.current.subscription = apiRef.current.store.subscribe(function() {
            var newState = applySelector(apiRef, refs.current.selector);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    EMPTY);
    var unsubscribe = React.useCallback(function() {
        return function() {
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, EMPTY);
    useSyncExternalStore(unsubscribe, subscribe, emptyGetSnapshot);
    return state;
};
// TODO v8: Rename this function to `useGridSelector`
export var useGridSelectorV8 = function(apiRef, selector) {
    var args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined, equals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultCompare;
    if (process.env.NODE_ENV !== 'production') {
        if (!apiRef.current.state) {
            warnOnce([
                'MUI X: `useGridSelector` has been called before the initialization of the state.',
                'This hook can only be used inside the context of the grid.'
            ]);
        }
    }
    var refs = useLazyRef(createRefs);
    var didInit = refs.current.selector !== null;
    var _React_useState = _sliced_to_array(React.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : applySelectorV8(apiRef, selector, args, apiRef.current.instanceId)), 2), state = _React_useState[0], setState = _React_useState[1];
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    var prevArgs = refs.current.args;
    refs.current.args = args;
    if (didInit && !argsEqual(prevArgs, args)) {
        var newState = applySelectorV8(apiRef, refs.current.selector, refs.current.args, apiRef.current.instanceId);
        if (!refs.current.equals(refs.current.state, newState)) {
            refs.current.state = newState;
            setState(newState);
        }
    }
    var subscribe = React.useCallback(function() {
        if (refs.current.subscription) {
            return null;
        }
        refs.current.subscription = apiRef.current.store.subscribe(function() {
            var newState = applySelectorV8(apiRef, refs.current.selector, refs.current.args, apiRef.current.instanceId);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    EMPTY);
    var unsubscribe = React.useCallback(function() {
        return function() {
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, EMPTY);
    useSyncExternalStore(unsubscribe, subscribe, emptyGetSnapshot);
    return state;
};
